import { Typography } from "@mui/material";

const NameRender = (text: string | number) => {
  return <Typography>{text}</Typography>;
}
export default NameRender;
